import { initialPropsExperimentConfig } from '@retail/funnel-components';

/**
 * @type {import('@retail/funnel-components/types/buildConfig/types').ICarleadCreationAppConfig}
 */
export const funnelOptions = {
  trackLandingPageType: 'lead',
  emailSuggestionEnabled: false,
  redirectOnSuccessUrl: '/se/booking/{hash}/',
  featuresFlags: {
    postalCode: true,
    honeyPotEmail: true,
    redirectToSelfEvaluation: true,
    selfEvaHideOnlinePriceBucket: true,
  },
  abExperiment: initialPropsExperimentConfig.carleadCreation,
  licensePlateFallbackPath: '/se/sell/17-1/',
  invalidLicensePlateFallbackPath: '/se/sell/17-1/',
};
